import { REOPEN_TICKET_START, REOPEN_TICKET_SUCCESS } from '../actions/actiontypes'

const INIT_STATE = {
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case REOPEN_TICKET_START:{
			return {...state};
		}
		case REOPEN_TICKET_SUCCESS:{
			return {...state, data:action.payload};
		}
		default:
			return state;
	}
}